import type { FieldValues } from "react-hook-form";
import type { MissingData } from "../../../../hooks/useMissingData";
import { camelize } from "../../../../utils/SnakeCamelConversion";
import type { FormFieldData } from "../Controllers/FormFieldController";

export function countMissingDataInTab(
  tabId: string,
  formFieldData: FormFieldData<FieldValues>,
  missingData: MissingData | null,
  ignoredFieldNames: string[] = []
) {
  const missingFields = Object.values(missingData?.missingFields ?? {}).flat();
  const fieldsInTab = Object.values(formFieldData).filter(
    (field) =>
      field && field.group === tabId && !ignoredFieldNames.includes(field.name)
  );

  const countMissingData = fieldsInTab.filter((fieldData) => {
    if (!fieldData) return false;
    const name = fieldData.name;
    const camelCaseName = camelize(name);

    return missingFields.some(
      (field) => camelCaseName.includes(field) || name.includes(field)
    );
  }).length;

  return countMissingData;
}
